import {
  NavigationGroup,
  ProcessPage,
  ProcessPageMain,
  ProcessPageMainContent,
  ProcessPageMainHeader,
  ProcessPageSidebar,
  ProcessPageSidebarNavigation,
  ProcessSidebarTrigger,
} from "@/shared/bsm/core/process/components/ui/process-page";
import t from "@/lang/lang";
import { Building2Icon, LayoutDashboard } from "lucide-react";
import { Separator } from "@/shared/components/ui/separator";
import { Outlet, useParams } from "react-router";
import {
  DocumentIconCalculation,
  DocumentIconOffer,
  DocumentIconRequirement,
} from "@/services/backend/documents/components/document-icon";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { useProcessesProcessShowQuery } from "@/services/backend/processes/api/process-api";
import { BreadcrumbsToDocument } from "@/shared/bsm/core/process/components/ui/breadcrumbs-to-document";
import { StateWarning } from "@/services/backend/processes/components/state/state-warning";
import { useFeatureAuth } from "@/services/backend/auth/hooks/use-feature-auth";
import { MainPageContent } from "@/routes/_components/main-page";
import { Alert403 } from "@/shared/components/alerts/alert-403";

export default function QPMRoute() {
  const { processId } = useParams();
  const {
    data: process,
    isLoading,
    error,
  } = useProcessesProcessShowQuery({
    id: processId ?? "",
  });

  const canAccess = useFeatureAuth("gsm.qpm");
  if (!canAccess) {
    return (
      <MainPageContent>
        <Alert403 />
      </MainPageContent>
    );
  }

  if (isLoading) {
    return null;
  }

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  return (
    <ProcessPage>
      <ProcessPageSidebar className="pt-16">
        <ProcessPageSidebarNavigation groups={sidebarNavigation} />
      </ProcessPageSidebar>
      <ProcessPageMain className="pt-16">
        <ProcessPageMainHeader className="justify-between">
          <div className="flex items-center gap-2">
            <ProcessSidebarTrigger />
            <Separator orientation="vertical" className="mr-2 h-4" />
            <BreadcrumbsToDocument process={process!} />
          </div>
          {/* <CloseProcessDialog processId={process!.id} /> */}
          <StateWarning processId={process!.id} />
        </ProcessPageMainHeader>
        <ProcessPageMainContent>
          <Outlet />
        </ProcessPageMainContent>
      </ProcessPageMain>
    </ProcessPage>
  );
}

const sidebarNavigation: NavigationGroup[] = [
  {
    label: t("Allgemein"),
    items: [
      {
        label: t("Übersicht"),
        icon: LayoutDashboard,
        to: "overview",
      },
      {
        label: t("Gebäudeverwaltung"),
        icon: Building2Icon,
        to: "manage-building",
      },
    ],
  },
  {
    label: t("Meilensteine"),
    items: [
      {
        label: t("Bestandsaufnahmen"),
        icon: DocumentIconRequirement,
        to: "requirements",
      },
      {
        label: t("Kalkulationen"),
        icon: DocumentIconCalculation,
        to: "calculations",
      },
      {
        label: t("Angebote"),
        icon: DocumentIconOffer,
        to: "offers",
      },
    ],
  },
];
